<template lang='pug'>
div.payment
  span.payment__subtitle(v-html="info.subtitle")
  ul.payment__list
    li.payment__item(
      v-for="(item, idx) in info.items"
      :key="item"
      :data-index="idx + 1")
      span.payment__text(v-html="item")
  ul.payment__footnote-list
   li.payment__footnote(v-for="note in info.footnote" v-html="note")
</template>

<script>
export default {
  name: 'PaymentComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },
  computed: {
    info() {
      return this.block.paymentInfo
    },
  }
}
</script>

<style lang='scss' scoped>
.payment {
  &__subtitle {
    display: inline-block;
    font-weight: bold;
    margin-bottom: 2.88rem;
  }

  &__list {
    display: flex;
    margin-bottom: 2.88rem;

    @media screen and (max-width: 1024px) {
      flex-direction: column;
      margin-bottom: 2rem;
    }
  }

  &__item {
    flex-basis: calc(100% / 3);
    padding-right: 0.6rem;
    padding-top: 3.88rem;
    position: relative;

    @media screen and (max-width: 1024px) {
      padding-top: 0;
      padding-left: 2.8rem;
      margin-left: 14px;

      &:not(:last-child) {
        padding-bottom: 2.3rem;
      }
    }
  }

  &__item:not(:last-child) {
    border-top: 2px solid $primary;

    @media screen and (max-width: 1024px) {
      border-top: none;
      border-left: 2px solid $primary;
    }
  }

  &__item::before {
    content: attr(data-index);
    color: white;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: $primary;
    top: -16px;
    left: 0;
    font-size: 20px;
    font-weight: bold;
    padding: 0 9px;

    @media screen and (max-width: 1024px) {
      top: 0;
      left: -16px;
    }
  }

  &__footnote {
    font-size: 13px;
    color: $gray;
    line-height: 1.4;
  }
}
</style>
